import { AxiosResponse } from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import { getResourceLinks as getResourceLinksService } from "../../services/resource-link/resource-link.service";
import {
    getResourceLinks,
    getResourceLinksFailure,
    getResourceLinksSuccess,
} from "../reducer/resource-links";

function* getResourceLinksSaga() {
    try {
        const { data }: AxiosResponse = yield call(getResourceLinksService);
        yield put(getResourceLinksSuccess(data));
    } catch (error: any) {
        yield put(getResourceLinksFailure(error));
    }
}

export function* rootSaga() {
    yield takeLatest(getResourceLinks.type, getResourceLinksSaga);
}
